import React, { useEffect } from "react";

export default function TestPdf() {

    useEffect(function () {
        loadPdf("testpdf.pdf");
    }, []);

    function loadPdf(url) {

        const loadingTask = pdfjsLib.getDocument(url);

        loadingTask.promise.then(function (pdf) {

            // 🔥 Extract ALL links (your main logic)
            extractAllLinks(pdf);
			
            // 🔹 Render first page (for now)
            pdf.getPage(1).then(function (page) {

                const scale = 1.5;
                const viewport = page.getViewport({ scale: scale });

                const canvas = document.getElementById("pdfCanvas");
                const context = canvas.getContext("2d");

                canvas.height = viewport.height;
                canvas.width = viewport.width;

                const renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };

                page.render(renderContext);

                // ✅ SAFE: annotations inside correct scope
                page.getAnnotations().then(function (annots) {
                    console.log("Page 1 annotations:", annots);
                });

            });

        });
    }


    function extractAllLinks(pdf) {

        let links = [];
        let totalPages = pdf.numPages;
        let promises = [];

        for (let pageNum = 1; pageNum <= totalPages; pageNum++) {

            let promise = pdf.getPage(pageNum).then(function (page) {

                return page.getAnnotations().then(function (annotations) {

                    annotations.forEach(function (a) {

                        if (a.subtype === "Link" && a.url) {

                            links.push({
                                page: pageNum,
                                type: "external",
                                url: a.url,
                                rect: a.rect
                            });
                        }

                        if (a.subtype === "Link" && a.dest) {

                            links.push({
                                page: pageNum,
                                type: "internal",
                                dest: a.dest,
                                rect: a.rect
                            });
                        }

                    });

                });

            });

            promises.push(promise);
        }

        return Promise.all(promises).then(function () {

            console.log("All links extracted:", links);

            return links;
        });
    }
	
	function extractAllText(pdf) {

	    let allText = [];
	    let totalPages = pdf.numPages;
	    let promises = [];

	    for (let pageNum = 1; pageNum <= totalPages; pageNum++) {

	        let promise = pdf.getPage(pageNum).then(function (page) {

	            return page.getTextContent().then(function (textContent) {

	                textContent.items.forEach(function (item) {

	                    let text = item.str;

	                    // 🔥 capture EVERYTHING first
	                    allText.push({
	                        page: pageNum,
	                        text: text,
	                        transform: item.transform
	                    });

	                    // 👀 also log for quick inspection
	                    console.log("TEXT:", text);

	                });

	            });

	        });

	        promises.push(promise);
	    }

	    return Promise.all(promises).then(function () {

	        console.log("ALL TEXT EXTRACTED:", allText);

	        return allText;
	    });
	}


    return (
        <div
            style={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <div style={{ width: "300px" }}>
                {/* Console panel placeholder */}
            </div>

            <canvas
                id="pdfCanvas"
                style={{ width: "calc(100% - 300px)" }}
            ></canvas>

        </div>
    );
}